var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import getMessage from 'src/background/utils/i18n.utils';
import { navigateToWithParams } from '@popup/multichain/actions/navigation.actions';
import { DelegationType } from '@popup/steem/pages/app-container/home/delegations/delegation-type.enum';
import { WalletInfoSectionActions, } from '@popup/steem/pages/app-container/home/wallet-info-section/wallet-info-section-actions';
import { WalletInfoSectionItemButton } from '@popup/steem/pages/app-container/home/wallet-info-section/wallet-info-section-item/wallet-info-section-item-button/wallet-info-section-item-button.component';
import TokensUtils from '@popup/steem/utils/tokens.utils';
import { Screen } from '@reference-data/screen.enum';
import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { SVGIcons } from 'src/common-ui/icons.enum';
import { PreloadedImage } from 'src/common-ui/preloaded-image/preloaded-image.component';
import { Separator } from 'src/common-ui/separator/separator.component';
import { SVGIcon } from 'src/common-ui/svg-icon/svg-icon.component';
import FormatUtils from 'src/utils/format.utils';
const walletInfoSectionItem = ({ tokenSymbol, tokenInfo, tokenBalance, tokenMarket, icon, addBackground, mainValue, mainValueLabel, subValue, subValueLabel, steem, pendingUnstaking, navigateToWithParams, }) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const [actionButtons, setActionButtons] = useState([]);
    const reff = useRef(null);
    const [hasButtonsInList, setHasButtonInList] = useState(false);
    useEffect(() => {
        init();
    }, []);
    const init = () => __awaiter(void 0, void 0, void 0, function* () {
        setActionButtons(WalletInfoSectionActions(tokenSymbol, tokenInfo, tokenBalance));
        if ((tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.delegationsOut) &&
            parseFloat(tokenBalance.delegationsOut) > 0) {
            setHasButtonInList(true);
        }
        if ((tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.delegationsIn) &&
            parseFloat(tokenBalance.delegationsIn) > 0) {
            setHasButtonInList(true);
        }
        if ((tokenBalance === null || tokenBalance === void 0 ? void 0 : tokenBalance.pendingUnstake) &&
            parseFloat(tokenBalance.pendingUnstake) > 0) {
            setHasButtonInList(true);
        }
    });
    const toggleDropdown = () => {
        setIsExpanded(!isExpanded);
    };
    const handleClick = (event, actionButton) => {
        event.stopPropagation();
        navigateToWithParams(actionButton.nextScreen, actionButton.nextScreenParams);
    };
    //  const handleHistoryClick = (
    //    event: BaseSyntheticEvent,
    //    tokenBalance?: TokenBalance,
    //  ) => {
    //    event.stopPropagation();
    //    if (tokenBalance) {
    //      navigateToWithParams(Screen.TOKENS_HISTORY, { tokenBalance });
    //    } else {
    //      navigateToWithParams(Screen.WALLET_HISTORY_PAGE, []);
    //    }
    //  };
    const handleHistoryClick = (event, tokenBalance) => {
        event.stopPropagation();
        if (tokenBalance) {
            navigateToWithParams(Screen.TOKENS_HISTORY, { tokenBalance });
        }
        else {
            navigateToWithParams(Screen.WALLET_HISTORY_PAGE, { tokenSymbol });
        }
    };
    const goToTokenWebsite = (token) => {
        chrome.tabs.create({ url: token.metadata.url });
    };
    const goToTokenOutgoingDelegations = () => {
        navigateToWithParams(Screen.TOKENS_DELEGATIONS, {
            tokenBalance: tokenBalance,
            delegationType: DelegationType.OUTGOING,
            tokenInfo: tokenInfo,
        });
    };
    const goToTokenIncomingDelegations = () => {
        navigateToWithParams(Screen.TOKENS_DELEGATIONS, {
            tokenBalance: tokenBalance,
            delegationType: DelegationType.INCOMING,
            tokenInfo: tokenInfo,
        });
    };
    const goToPendingUnstakePage = () => {
        navigateToWithParams(Screen.TOKENS_PENDING_UNSTAKE, {
            tokenInfo: tokenInfo,
            pendingUnstaking: pendingUnstaking,
        });
    };
    return (React.createElement("div", { className: `wallet-info-row ${isExpanded ? 'opened' : ''}`, "data-testid": `wallet-info-section-row`, ref: reff, onClick: () => {
            var _a;
            toggleDropdown();
            !process.env.IS_FIREFOX &&
                ((_a = reff.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: 'center',
                }));
        } },
        React.createElement("div", { className: "information-panel" },
            !tokenInfo && (React.createElement(SVGIcon, { icon: icon, className: `currency-icon ${addBackground ? 'add-background' : ''}` })),
            tokenInfo && (React.createElement(PreloadedImage, { src: tokenInfo === null || tokenInfo === void 0 ? void 0 : tokenInfo.metadata.icon, className: "currency-icon", addBackground: true, symbol: tokenInfo.symbol, useDefaultSVG: icon })),
            React.createElement("div", { className: "main-value-label" }, mainValueLabel),
            React.createElement("div", { className: "value" },
                React.createElement("div", { className: "main-value" }, FormatUtils.formatCurrencyValue(mainValue)),
                !!subValue &&
                    parseFloat(FormatUtils.formatCurrencyValue(subValue)) !== 0 && (React.createElement("div", { className: "sub-value" },
                    parseFloat(subValue === null || subValue === void 0 ? void 0 : subValue.toString()) > 0 ? '+' : '',
                    FormatUtils.formatCurrencyValue(subValue),
                    " (",
                    subValueLabel,
                    ")"))),
            isExpanded && (React.createElement(SVGIcon, { icon: SVGIcons.WALLET_HISTORY_BUTTON, className: `history-icon`, onClick: ($event) => handleHistoryClick($event, tokenBalance), hoverable: true }))),
        isExpanded && (React.createElement(React.Fragment, null,
            tokenInfo && tokenBalance && tokenMarket && (React.createElement("div", { className: `token-info-panel ${hasButtonsInList ? 'has-button-in-list' : ''}` },
                tokenInfo.issuer && tokenInfo.issuer !== 'null' && (React.createElement(React.Fragment, null,
                    React.createElement("div", { "data-testid": `token-info-go-to-website-${tokenBalance.symbol}`, className: "token-info-row", onClick: () => goToTokenWebsite(tokenInfo) },
                        React.createElement("div", { className: "label" }, getMessage('html_tokens_issuer')),
                        React.createElement("div", { className: "value" },
                            React.createElement("span", { className: "token-issuer" },
                                "@",
                                tokenInfo.issuer)),
                        React.createElement("div", null)),
                    React.createElement(Separator, { type: "horizontal" }))),
                React.createElement("div", { className: "token-info-row" },
                    React.createElement("div", { className: "label" }, getMessage('token_value')),
                    React.createElement("div", { className: "value" },
                        "$",
                        TokensUtils.getHiveEngineTokenValue(tokenBalance, 
                        // tokenMarket,
                        steem, [tokenInfo]).toFixed(2),
                        ' ',
                        "($",
                        (TokensUtils.getHiveEngineTokenPrice(tokenBalance, tokenMarket) * (steem === null || steem === void 0 ? void 0 : steem.usd)).toFixed(2),
                        "/",
                        getMessage('token').toLowerCase(),
                        ")"),
                    React.createElement("div", null)),
                React.createElement(Separator, { type: "horizontal" }),
                React.createElement("div", { className: "token-info-row" },
                    React.createElement("div", { className: "label" }, getMessage('liquid_balance')),
                    React.createElement("div", { className: "value" }, FormatUtils.trimUselessZero(parseFloat(tokenBalance.balance), tokenInfo.precision)),
                    React.createElement("div", null)),
                tokenInfo.stakingEnabled && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement("div", { className: "token-info-row" },
                        React.createElement("div", { className: "label" },
                            getMessage('popup_html_token_staking'),
                            ' '),
                        React.createElement("div", { className: "value" }, FormatUtils.trimUselessZero(parseFloat(tokenBalance.stake), tokenInfo.precision)),
                        React.createElement("div", null)))),
                tokenInfo.stakingEnabled &&
                    parseFloat(tokenBalance.pendingUnstake) > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement("div", { className: "token-info-row", onClick: goToPendingUnstakePage },
                        React.createElement("div", { className: "label" }, getMessage('popup_html_token_pending_unstake')),
                        React.createElement("div", { className: "value" }, FormatUtils.trimUselessZero(parseFloat(tokenBalance.pendingUnstake), tokenInfo.precision)),
                        React.createElement("div", { className: "icon" }, parseFloat(tokenBalance.pendingUnstake) > 0 && (React.createElement(SVGIcon, { className: "go-to-page-icon", icon: SVGIcons.WALLET_TOKEN_GO_TO_DETAILED_PAGE })))))),
                tokenInfo.delegationEnabled && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement("div", { "data-testid": `button-go-to-outgoing-delegations-${tokenBalance.symbol}`, className: "token-info-row", onClick: goToTokenIncomingDelegations },
                        React.createElement("div", { className: "label" }, getMessage('popup_html_token_delegation_in')),
                        React.createElement("div", { className: "value" }, FormatUtils.trimUselessZero(parseFloat(tokenBalance.delegationsIn), tokenInfo.precision)),
                        React.createElement("div", { className: "icon" }, parseFloat(tokenBalance.delegationsIn) > 0 && (React.createElement(SVGIcon, { className: "go-to-page-icon", icon: SVGIcons.WALLET_TOKEN_GO_TO_DETAILED_PAGE })))))),
                tokenInfo.delegationEnabled &&
                    parseFloat(tokenBalance.delegationsOut) > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement("div", { "aria-label": "button-go-to-outgoing-delegations", className: "token-info-row", onClick: goToTokenOutgoingDelegations },
                        React.createElement("div", { className: "label" }, getMessage('popup_html_token_delegation_out')),
                        React.createElement("div", { className: "value" },
                            ' ',
                            FormatUtils.trimUselessZero(parseFloat(tokenBalance.delegationsOut), tokenInfo.precision)),
                        React.createElement("div", { className: "icon" }, parseFloat(tokenBalance.delegationsOut) > 0 && (React.createElement(SVGIcon, { className: "go-to-page-icon", icon: SVGIcons.WALLET_TOKEN_GO_TO_DETAILED_PAGE })))))),
                tokenInfo.delegationEnabled &&
                    parseFloat(tokenBalance.pendingUndelegations) > 0 && (React.createElement(React.Fragment, null,
                    React.createElement(Separator, { type: "horizontal" }),
                    React.createElement("div", { className: "token-info-row" },
                        React.createElement("div", { className: "label" }, getMessage('popup_html_token_pending_undelegation')),
                        React.createElement("div", { className: "value" }, tokenBalance.pendingUndelegations),
                        React.createElement("div", null)))))),
            React.createElement("div", { className: "actions-panel" }, actionButtons.map((ab, index) => (React.createElement(WalletInfoSectionItemButton, { key: `action-${ab.label}-${index}`, actionButton: ab, handleClick: handleClick }))))))));
};
const mapStateToProps = (state) => {
    return {
        globalProperties: state.steem.globalProperties,
        steem: state.steem.currencyPrices.steem,
        pendingUnstaking: state.steem.tokensPendingUnstaking,
    };
};
const connector = connect(mapStateToProps, {
    navigateToWithParams,
});
export const WalletInfoSectionItemComponent = connector(walletInfoSectionItem);
